import React, { Component } from 'react';
//import featured_image from './home.jpg';
import './Home.scss';

export default class Home extends Component {
  componentDidMount() {
    //console.log('home init ' + featured_image);
    // need to size the intro div to fill the window height
    /*
    $(".home-banner").height($(window).height());

    $(window).resize(function(){
      $(".home-banner").height($(window).height());
    });

    $('#home').parallax({imageSrc: `${featured_image}`});
    */
    // https://stackoverflow.com/questions/22115916/background-video-with-parallax-effect
    // try https://github.com/linnett/backgroundVideo ?

    // sizing video with CSS, could use JS:
    //document.getElementById("home-video").width = document.body.offsetWidth;
  }

  render() {
    return (
      <section id="home" ref="banner" className="home-banner">
        {/* <video id="home-video" poster="/intro_first_frame.jpg" > */}
        <video id="home-video" autoPlay muted loop playsInline poster="/intro.gif">
          <source src="intro.mp4" type="video/mp4" />
          <source src="intro.ogg" type="video/ogg" />
          Your browser does not support the video element.
        </video>
        <div className="container">
          <div className="welcome-text">
            <h3>Tech Lead</h3>
            <p>MOBILE APPS | WEB APPS | FULL-STACK DEVELOPER | ARCHITECTURE | DATA DESIGN</p>
            <div className="wt-actions">
              <button className="m-btn lets-talk">Let&apos;s talk Now</button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Home.js